import React, {
  VoidFunctionComponent,
  ComponentProps,
  PropsWithChildren
} from 'react';
import { CardListItemGroup } from 'record-it-components/cardList/CardListItemGroup/CardListItemGroup';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { EntityName } from 'record-it-time-common/EntityName';
import { ImmutableStopwatchInfo } from '../../../classes/timeTracking/ImmutableStopwatch/ImmutableStopwatch';
import { useGroupedByUserGroup } from '../../../hooks/group/useGroupedByUserGroup/useGroupedByUserGroup';
import { useEntities } from '../../../hooks/entity/useEntities/useEntities';
import { StopwatchListItem } from '../StopwatchListItem/StopwatchListItem';

export type StopwatchListProps = PropsWithChildren<ComponentProps<'div'>> & {
  stopwatchInfos: Array<ImmutableStopwatchInfo>;
};

export const StopwatchList: VoidFunctionComponent<StopwatchListProps> =
  React.memo((props) => {
    const { stopwatchInfos, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    const userGroups = useEntities(EntityName.UserGroup, 'getAll');
    const groupedInfos = useGroupedByUserGroup(stopwatchInfos, (info) =>
      info.getUserGroupId()
    );

    return (
      <div {...remainingProps}>
        {groupedInfos.map((group) => (
          <CardListItemGroup
            key={group.key}
            label={userGroups.length > 1 ? group.label : ''} // hide the label when there is only one userGroup
          >
            {group.items.map((info) => (
              <StopwatchListItem
                key={info.getId()}
                stopwatchInfo={info}
                data-testid="StopwatchList.ListItem"
              ></StopwatchListItem>
            ))}
          </CardListItemGroup>
        ))}
      </div>
    );
  });
